import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { isEmpty } from 'lodash';

import { Component, Input, OnInit, OnChanges, SimpleChanges, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

import { environment } from '../../../../../environments/environment';
import { untilDestroyed } from 'ngx-take-until-destroy';

@Component({
  selector: 'kt-user-avatar',
  templateUrl: './user-avatar.component.html',
  styleUrls: ['./user-avatar.component.scss'],
})
export class UserAvatarComponent implements OnInit, OnDestroy, OnChanges {
  @Input() user: any;
  avatarStyle: BehaviorSubject<SafeStyle> = new BehaviorSubject<SafeStyle>('');

  constructor(private sanitizer: DomSanitizer, private http: HttpClient, private cd: ChangeDetectorRef) {}

  ngOnInit() {}

  ngOnDestroy() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.user) {
      this.setAvatarStyle();
    }
  }

  setAvatarStyle() {
    if (!isEmpty(this.user)) {
      const avatarUrl = `${environment.apiPrefix}/users/${this.user.id}/avatar`;

      this.http
        .get(avatarUrl, { responseType: 'text' })
        .pipe(untilDestroyed(this))
        .subscribe((avatar) => {
          if (avatar) {
            avatar = avatar.replace(/(\r\n|\n|\r)/gm, '');
            this.avatarStyle.next(this.sanitizer.bypassSecurityTrustStyle(`background-image: url(${avatar});`));
            this.cd.detectChanges();
          }
        });
    }
  }
}
